import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { addCustomer as addCustomerAPI } from "api/customers";
import { customersKeys } from "api/customers/queries";
import { NewCustomerPayloadType } from "api/customers/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import CustomerForm, { CustomerFormValues } from "./CustomerForm";

// LOGIC:

// TYPES:

interface NewCustomerModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const NewCustomerModal = ({ isOpen, handleClose }: NewCustomerModalProps) => {
  const queryClient = useQueryClient();

  const { mutateAsync: addCustomer, status } = useMutation(
    async (data: NewCustomerPayloadType) => {
      const res = await addCustomerAPI(data);
      await queryClient.invalidateQueries(customersKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: CustomerFormValues) => {
    await addCustomer(
      {
        ...values,
      },
      {
        onSuccess: () => handleClose(),
      },
    );
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="lg">
      <ModalHeader
        title="New Customer"
        subtitle="Add a new customer and their contact information."
      />

      <CustomerForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />
    </AppDialog>
  );
};

export default NewCustomerModal;
